import { StatusCodes } from "http-status-codes";
import { request } from "../../api";
import { headers } from "../../../../config/config";
import { MESSAGE } from "../../../../constants/api/message";
import { AUTHORIZATION } from "../../../../constants/api/auth";
import { Member } from "../../../../@types/member.types";

const { post, get, patch } = request;
const { Authorization, Bearer } = AUTHORIZATION;

const initialRoute = "member";

// eslint-disable-next-line arrow-parens
export const editDependentProfileInformationById = async (_payload: Member, params: string) => {
	try {
		const payload = JSON.stringify(_payload);
		const endpoint = `${initialRoute}/edit-dependent-information/${params}`;
		const token = localStorage.getItem("@jwt");
		const response = await patch(endpoint, payload, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === "Dependent Profile Information Updation Successful!") {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (error: any) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			if (message === MESSAGE.none) {
				alert("No Such Data!");
			} else if (message === "Dependent Profile Information Updation Unsuccessful!") {
				alert("Dependent Profile Information Updation Unsuccessful!");
			} else alert("Other Errors of Status Code 400");
		} else if (error.response.status === StatusCodes.UNAUTHORIZED) {
			const { message } = error.response.data;

			if (message === "Authentication Failed!") {
				alert("Authentication Failed!");
				// throw error;
			} else {
				throw error;
				//alert("Other Errors of Status Code 401");
			}
		} else {
			throw error;
		}
	}
};
